import domReady from '@wordpress/dom-ready';

domReady(() => {
  const hash = window.location.hash;
  if (!hash) return;

  const id = hash.slice(1);
  const button = document.getElementById(id);

  if (
    button &&
    button.classList.contains('wp-block-accordion-heading__toggle')
  ) {
    button.click();
    button.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
});
